module.exports = __webpack_public_path__ + "static/img/yyrwh.27db7e34.gif";